import { render, staticRenderFns } from "./GfoOrderTicket.vue?vue&type=template&id=d5c979c2&"
import script from "./GfoOrderTicket.vue?vue&type=script&lang=js&"
export * from "./GfoOrderTicket.vue?vue&type=script&lang=js&"
import style0 from "./GfoOrderTicket.vue?vue&type=style&index=0&id=d5c979c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GfoOrderTicket.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports